<template>
    <div :class="marketingItemClasses">
        <div class="upsell-marketing-item__text">
            <div class="upsell-marketing-item__text-label">
                <p class="typographies-paragraph-medium-regular">
                    {{ label }}
                </p>
                <CompassTooltip :content="tooltipText" content-class="tooltipUpsellMarketingItem">
                    <CompassIcon icon="info-circle-fill" size="small" type="secondary" />
                </CompassTooltip>
            </div>
            <p
                v-if="description.length > 0"
                class="upsell-marketing-item__text-description typographies-paragraph-small-regular"
            >
                {{ description }}
            </p>
        </div>
        <div class="upsell-marketing-item__choice">
            <CompassTooltip
                v-if="!enabled"
                :content="
                    $t.__(
                        'pages.account.upsell.marketing.ChargebeeUpsellMarketingItem.option_not_available',
                    )
                "
                content-class="tooltipUpsellMarketingItem"
            >
                <CompassFeatureBadge
                    v-if="!enabled"
                    :is-interactive="false"
                    size="small"
                    variant="upsell"
                />
            </CompassTooltip>
            <slot />
            <p class="upsell-marketing-item__price">
                <span class="typographies-paragraph-medium-semibold">
                    {{ $filters.numberFormatCurrency(humanizeCentsPrice(amount)) }}
                </span>
                <span class="typographies-paragraph-medium-regular">
                    /{{ recurrencyLabel(getRecurrence) }}
                </span>
            </p>
        </div>
    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import ChargebeeUpsellMixin from 'mixins/chargebee/ChargebeeUpsellMixins';

const chargebeeUpsellStore = createNamespacedHelpers('chargebeeUpsellStore');
export default {
    mixins: [ChargebeeUpsellMixin],
    props: {
        amount: {
            type: Number,
            required: true,
        },
        enabled: {
            type: Boolean,
            required: false,
            default: true,
        },
        tooltipText: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...chargebeeUpsellStore.mapGetters(['getRecurrence']),
        marketingItemClasses() {
            return [
                'upsell-marketing-item',
                !this.enabled ? 'upsell-marketing-item--disabled' : '',
            ];
        },
    },
};
</script>

<style lang="scss">
.upsell-marketing-item {
    align-items: center;
    display: flex;
    gap: var(--spacing-3);
    justify-content: space-between;

    p {
        margin: 0;
    }

    &__text {
        display: flex;
        flex-direction: column;

        &-label {
            align-items: center;
            color: var(--colors-common-text-standard-default);
            display: flex;
            gap: var(--spacing-0);
            white-space: nowrap;
        }

        &-description {
            color: var(--colors-common-text-standard-caption);
            max-width: 260px;
        }
    }

    &__price {
        color: var(--colors-common-text-standard-default);
        display: flex;
        justify-content: flex-end;
        white-space: nowrap;
        width: 88px;
    }

    &__choice {
        align-items: center;
        display: flex;
        gap: var(--spacing-3);

        .compass-select {
            width: 140px;
        }
    }

    &--disabled {
        .upsell-marketing-item__text {
            &-label {
                color: var(--colors-common-text-standard-disabled);
            }

            &-description {
                color: var(--colors-common-text-standard-disabled);
            }
        }

        .upsell-marketing-item__price {
            color: var(--colors-common-text-standard-disabled);
        }
    }
}

.tooltipUpsellMarketingItem {
    max-width: 272px;
}
</style>
